/** 大陆 / 非大陆资料步号（无组件 import，避免 risk 包拖入整表单） */
export const STEPS_MAINLAND = {
  SelectIDCard: 2,
  UploadLic: 3,
  UploadBank: 4,
  Address: 5,
  JobStatus: 6,
  FinancialStatus: 7,
  InvestmentExp: 8,
  TaxInfo: 9,
  Others: 10,
  ActivateEleServices: 11,
  SelectAccount: 12,
} as const;

export const STEPS_NON_MAINLAND = {
  SelectIDCard: 2,
  UploadLic: 3,
  Address: 4,
  JobStatus: 5,
  FinancialStatus: 6,
  InvestmentExp: 7,
  TaxInfo: 8,
  Others: 9,
  ActivateEleServices: 10,
  SelectAccount: 11,
} as const;

export type InfoStepKey = keyof typeof STEPS_MAINLAND;

export const isMainlandIdCard = (idCardType?: string) => idCardType === 'MAINLAND_CHINA';

/** 按资料页 key 取 step；UploadBank 仅大陆有 */
export function stepOf(key: InfoStepKey, isMainland: boolean): number {
  if (key === 'UploadBank') {
    if (!isMainland) {
      throw new Error('stepOf: UploadBank is mainland-only');
    }
    return STEPS_MAINLAND.UploadBank;
  }
  return isMainland ? STEPS_MAINLAND[key] : STEPS_NON_MAINLAND[key];
}

/** @deprecated 使用 stepOf；保留兼容旧调用签名会拖组件依赖，已移除 */
export function resolveStep(_component: unknown, _isMainland: boolean): number {
  throw new Error('resolveStep(component) removed — use stepOf(key, isMainland)');
}
